import React from "react";
import { Grid } from "@material-ui/core";
import { useQuery } from '@apollo/react-hooks';
import TileDefault from "../../Tiles/Default/TileDefault";
import { GET_REVENUE } from "../../../queries/indicators";
import PageError from '../../PageError';
import PageLoading from '../../PageLoading';
import { momentFormat } from "../../Utils/formatters";
import { moment } from "../../Utils/momentConfig";


let card = [];

export default function RevenueIndicator(props) {
  var { publishers } = props;
  let { data: dataIndicatorsRevenue, error: errorRevenue, loading: loadingRevenue } = useQuery(GET_REVENUE, {
    variables: { publishers: publishers },
  });


  if(dataIndicatorsRevenue){
    const rowRevenue = dataIndicatorsRevenue.reportRevenueByPublisher;
    card = [
      {
        product: "Revenue",
        today: { value: rowRevenue.todayRevenue ? rowRevenue.todayRevenue.toFixed(2): 0 },
        week : rowRevenue.sevenDaysByDaysRevenue ? rowRevenue.sevenDaysByDaysRevenue.map(row => ({ quantity: row.value ? row.value.toFixed(2) : "0", 
        dateSubscribed: moment(row.date).add(1, 'days').format(momentFormat) })): [],
        yesterday: { value: rowRevenue.yesterdayRevenue ? rowRevenue.yesterdayRevenue.toFixed(2): 0 },
        weekly: { value: rowRevenue.sevenDaysRevenue ? rowRevenue.sevenDaysRevenue.toFixed(2): 0 },
        monthly: { value: rowRevenue.monthRevenue ? rowRevenue.monthRevenue.toFixed(2): 0 },
        color: "primary",
        isAvg: false,
        isCurrency: true
      }
    ];
  }

  
  return (
    <>
      {(loadingRevenue) ? <Grid item xs={12}><PageLoading /></Grid> : 
      (errorRevenue) ? <Grid item xs={12}><PageError /></Grid> :
        (
          <>
            {
              card.map(stat => (
                  <Grid item md={4} sm={6} xs={12} key={stat.product}>
                    <TileDefault {...stat} />
                  </Grid>
              ))
            }
          </>
        )
      }
    </>
  );
}